/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfTransaction } from '../../models/data-page-of-transaction';

export interface TransactionList$Params {
}

export function transactionList(http: HttpClient, rootUrl: string, params?: TransactionList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfTransaction>> {
  const rb = new RequestBuilder(rootUrl, transactionList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfTransaction>;
    })
  );
}

transactionList.PATH = '/transaction/list';
